import type { PortalPreset } from '../types/portal-settings';
import comingSoon from './coming-soon';
import genericSupport from './generic-support';
import helicopterMapping from './helicopter-mapping';
import limousineCustomer from './limousine-customer';
import towingCustomer from './towing-customer';
import towingMapping from './towing-mapping';
import towingSupplier from './towing-supplier';

/**
 * Opt out of the preset layer entirely: catalogue defaults plus the deployment's
 * own settings. Reserved, so it can never collide with a real preset name.
 */
export const NO_PRESET = 'none';

/**
 * Preset names are a cross-repo contract with no compile-time link to the
 * registry: a deployment names one as a string. Resolution throws on an unknown
 * name so the mistake fails THIS build, which is the only place it can be
 * caught (the registry cannot know an app's preset list).
 */
export const PORTAL_PRESETS: Record<string, PortalPreset> = {
	'towing-customer': towingCustomer,
	'towing-supplier': towingSupplier,
	'towing-mapping': towingMapping,
	'limousine-customer': limousineCustomer,
	'helicopter-mapping': helicopterMapping,
	'generic-support': genericSupport,
	'coming-soon': comingSoon,
};
